import type { FC } from "react"

import { z } from "zod"

import { TextInput } from "./TextInput"

interface IEmailInputProps {
  id?: string
  label?: string
  value: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
  showIcon?: boolean
}

export const emailSchema = z.string().email()

const isEmail = (value: string): string | undefined => {
  try {
    const res = emailSchema.parse(value)

    return undefined
  } catch (e) {
    return `must be a valid email`
  }
}

export const EmailInput: FC<IEmailInputProps> = ({
  label,
  value,
  id,
  onChange,
  disabled,
  showIcon = true,
}) => {
  return (
    <TextInput
      disabled={disabled}
      error={isEmail(value)}
      label={label}
      type="email"
      id={id ?? `email`}
      onChange={onChange}
      value={value}
      showIcon={showIcon}
    />
  )
}
